<template>
  <el-dialog :visible="visible" @open="open" @close="close" fullscreen :close-on-click-modal="false" append-to-body class="editor">
    <el-row slot="title">
      <el-tag :type="auditTagType" size="mini" effect="plain">{{ verEntity.auditState }}</el-tag>
      {{ tmpl.scope }}文书模板<span v-if="verEntity.auditState == Enum.MrAuditState.审批中">审批</span><span v-else>设计</span>：
      <b>{{ tmpl.name }}</b>
      <span v-if="verEntity.ver">{{ `${verEntity.ver}.0` }}</span>
      <small>（{{ tmpl.deptCode | dictText("Dept") }}-{{ tmpl.category | dictText("MrCategory") }}-{{ tmpl.type | dictText("MrType") }}）</small>
      <el-button v-if="!isAudit" type="primary" @click="editTmpl" size="mini" icon="el-icon-edit" circle plain> </el-button>
    </el-row>
    <el-container class="f-h">
      <el-aside width="17rem" style="padding: 0.5rem" v-show="meta.showAside">
        <el-collapse v-if="isEdit" v-model="meta.actCollapseItem" @change="collapseChange">
          <el-collapse-item title="元素" name="1">
            <b slot="title"><i class="el-icon-platform-eleme" /> 文档元素 </b>
            <el-input size="mini" v-model="eles.keyword" clearable placeholder="元素名称"></el-input>
            <el-table :data="validEles" style="width: 100%" size="mini" max-height="350" @filter-change="eleFilterChanged">
              <el-table-column prop="name" label="名称">
                <template slot-scope="{ row }">
                  <el-link size="mini" @click="insert(row)">{{ row.name }}</el-link>
                </template>
              </el-table-column>
              <el-table-column prop="type" label="类型" width="60" align="center" :filters="dictEnum.MrElementType" :filter-multiple="false" column-key="type"> </el-table-column>
              <el-table-column label="" width="50" align="right">
                <template slot-scope="{ row }">
                  <el-button type="primary" size="mini" icon="el-icon-arrow-right" @click="insert(row)" circle plain> </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>
          <el-collapse-item title="元素属性" name="2">
            <b slot="title"><i class="el-icon-eleme" /> 元素属性 </b>
            <el-table :data="eles.actProps" style="width: 100%" size="mini" :show-header="false" :cell-style="cellStyle" empty-text="请选择元素">
              <el-table-column prop="text" label="属性名" align="right"> </el-table-column>
              <el-table-column label="设置" align="left">
                <template slot-scope="{ row }">
                  <span v-if="row.type == 'lb'" size="mini" type="info">{{ row.value }}</span>
                  <!-- <el-button v-if="row.type == 'data'" type="text" size="mini">{{ row.value }} <i class="el-icon-edit" /></el-button> -->
                  <el-cascader v-if="row.type == 'data'" :options="srcDataTree" v-model="row.value" size="mini" :props="{ checkStrictly: true, expandTrigger: 'hover', label: 'text', value: 'code', children: 'props' }" clearable @change="propChanged(row)" :show-all-levels="false"></el-cascader>
                  <el-input v-if="row.type == 'str'" type="text" size="mini" v-model="row.value" style="width: 100%" @change="propChanged(row)" />
                  <el-input-number v-if="row.type == 'num'" size="mini" v-model="row.value" style="width: 100%" @change="propChanged(row)" />
                  <el-switch v-if="row.type == 'bool'" size="mini" v-model="row.value" style="width: 100%" @change="propChanged(row)" />
                  <el-date-picker v-if="row.type == 'dt'" size="mini" v-model="row.value" style="width: 100%" @change="propChanged(row)" />
                  <el-select v-if="row.type == 'opt'" size="mini" v-model="row.value" style="width: 100%" @change="propChanged(row)">
                    <el-option v-for="opt in row.opts" :key="opt.code" :value="opt.code" :label="opt.text" />
                  </el-select>
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>
          <el-collapse-item title="输入结构" name="meta">
            <b slot="title"><i class="el-icon-s-fold" /> 输入结构 </b>
            <el-tree :data="inDataTree" node-key="code" @node-click="insertMeta" :props="editorUtils.eleTreeProp">
              <small slot-scope="{ node, data }">
                <i :class="editorUtils.eleIcon(data)" />
                {{ node.label }}
              </small>
            </el-tree>
          </el-collapse-item>
          <el-collapse-item title="输出结构" name="struct">
            <b slot="title"><i class="el-icon-s-unfold" /> 输出结构 </b>
            <el-tree :data="outDataTree" default-expand-all highlight-current :expand-on-click-node="false" @node-click="nodeClick">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
                <el-button v-if="data.isRoot" type="text" icon="el-icon-refresh" circle size="small" @click="refreshStruct"></el-button>
              </span>
            </el-tree>
          </el-collapse-item>
          <el-collapse-item v-if="verEntity.auditLogs" title="审批记录" name="5">
            <b slot="title"><i class="el-icon-s-check" /> 审批记录 </b>
            <el-timeline>
              <el-timeline-item placement="top" v-for="(log, index) in JSON.parse(verEntity.auditLogs)" :key="index" :type="log.auditResult == '未通过' ? 'danger' : 'success'" :timestamp="log.auditDate">
                {{ log.auditName }}： {{ log.auditResult }}
                <p v-if="log.reason">{{ log.reason }}</p>
              </el-timeline-item>
            </el-timeline>
          </el-collapse-item>
        </el-collapse>
        <el-collapse v-if="isAudit" v-model="meta.actCollapseItem" accordion @change="collapseChange">
          <el-collapse-item title="审批意见" name="1">
            <b slot="title"><i class="el-icon-s-check" /> 审批意见 </b>
            <el-input type="textarea" v-model="reason"></el-input>
          </el-collapse-item>
          <el-collapse-item title="输出结构" name="struct">
            <b slot="title"><i class="el-icon-s-order" /> 输出结构 </b>
            <el-tree :data="outDataTree" default-expand-all highlight-current :expand-on-click-node="false" @node-click="nodeClick">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
                <el-button v-if="data.isRoot" type="text" icon="el-icon-refresh" circle size="small" @click="refreshStruct"></el-button>
              </span>
            </el-tree>
          </el-collapse-item>
        </el-collapse>
      </el-aside>
      <el-main ref="main">
        <el-row ref="editor" class="f-h"> </el-row>
      </el-main>
    </el-container>
    <span slot="footer" class="dialog-footer" style="height: 1px">
      <el-button-group class="pull-left left-pad">
        <el-button type="primary" :icon="meta.showAside ? 'el-icon-reading' : 'el-icon-notebook-1'" @click="switchSideShow" title="辅助切换"></el-button>
        <el-button type="primary" icon="el-icon-printer" @click="print" title="打印"></el-button>
        <el-button type="primary" icon="el-icon-plus" @click="addMrPart" title="添加病历段"></el-button>
      </el-button-group>
      <el-button type="info" @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button v-if="!isAudit" type="primary" @click="save(false)" :disabled="meta.saving" :loading="meta.saving">暂 存 </el-button>
      <el-button v-if="!isAudit" type="warning" @click="save(true)" :disabled="meta.saving" :loading="meta.saving">提 交</el-button>
      <el-button v-if="isAudit" type="danger" @click="audit(false)" :disabled="meta.saving" :loading="meta.saving">打 回</el-button>
      <el-button v-if="isAudit" type="success" @click="audit(true)" :disabled="meta.saving" :loading="meta.saving">通 过</el-button>
    </span>
    <edit :visible.sync="meta.showEdit" v-model="tmplEntity" @saved="tmplSaved" hide-disabled />
  </el-dialog>
</template>

<script>
  import editorUtils, { genStructData } from "@/common/editorUtils";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      visible: Boolean,
      tmpl: Object,
      editingVer: Object,
      apis: Array,
    },
    components: {
      edit: () => import("./edit"),
    },
    data() {
      return {
        verEntity: {},
        tmplEntity: {},
        reason: null,
        apiItems: [],
        meta: {
          showAside: true,
          showEdit: false,
          saving: false,
          actCollapseItem: "1",
        },
        eles: {
          options: [],
          type: null,
          keyword: null,
          actName: null,
          actProps: [],
          actType: null,
        },
        editorUtils: editorUtils,
      };
    },
    computed: {
      ...mapGetters(["Enum", "dict", "dictEnum", "user", "setting"]),
      isEdit() {
        return this.verEntity.auditState == this.Enum.MrAuditState.草稿 || this.verEntity.auditState == this.Enum.MrAuditState.未通过;
      },
      isAudit() {
        return this.verEntity.auditState == this.Enum.MrAuditState.审批中;
      },
      auditTagType() {
        switch (this.verEntity.auditState) {
          case this.Enum.MrAuditState.审批中:
            return "warning";
          case this.Enum.MrAuditState.通过:
            return "success";
          case this.Enum.MrAuditState.未通过:
            return "danger";
          default:
            return "primary";
        }
      },
      outDataTree() {
        return [
          {
            isRoot: true,
            label: "文档",
            children: this.genTree(this.tmpl.docStruct),
          },
        ];
      },
      inDataTree() {
        let treedata = [];
        treedata.push({
          code: "main",
          text: "当前病历",
          type: "obj",
          props: [
            {
              code: "opNo",
              text: "门诊号",
              type: "str",
            },
            {
              code: "ipNo",
              text: "住院号",
              type: "str",
            },
            {
              code: "archiveNo",
              text: "档案号",
              type: "str",
            },
            {
              code: "patientCode",
              text: "患者编码",
              type: "str",
            },
            {
              code: "patientName",
              text: "患者姓名",
              type: "str",
            },
            {
              code: "patientGender",
              text: "患者性别",
              type: "dict",
              dict: "Gender",
            },
            {
              code: "patientAge",
              text: "患者年龄",
              type: "str",
            },
            {
              code: "deptCode",
              text: "科室编码",
              type: "str",
            },
            {
              code: "doctorCode",
              text: "医生编码",
              type: "str",
            },
            {
              code: "doctorName",
              text: "医生姓名",
              type: "str",
            },
            {
              code: "diagnosis",
              text: "主要诊断",
              type: "str",
            },
            {
              code: "opTime",
              text: "就诊时间",
              type: "str",
            },
          ],
        });
        treedata.push({
          code: "mr",
          text: "当前文书",
          type: "obj",
          props: [
            {
              code: "tmplCode",
              text: "模板编码",
              type: "str",
            },
            {
              code: "mrDate",
              text: "文书追加日期",
              type: "str",
            },
            {
              code: "doctorName",
              text: "文书追加者姓名",
              type: "str",
            },
          ],
        });
        treedata.push({
          code: "user",
          text: "当前用户",
          type: "obj",
          props: [
            {
              code: "name",
              text: "姓名",
              type: "str",
            },
            {
              code: "deptName",
              text: "科室",
              type: "str",
            },
            {
              code: "tenantName",
              text: "机构名称",
              type: "str",
            },
          ],
        });
        this.apiItems.forEach((a) => {
          try {
            treedata.push(JSON.parse(a.struct));
          } catch (e) {
            console.log("`解析API(${a.code}：${a.name})出错：`", e);
          }
        });
        // console.log(treedata);

        return treedata;
      },
      srcDataTree() {
        let parent = editorUtils.getEleParent(this.$editor, this.eles.actName);
        if (parent) {
          let branch = editorUtils.getBranch(this.inDataTree, parent.getRes);
          return branch;
        }

        return this.inDataTree;
      },
      validEles() {
        return this.eles.options.filter((e) => (!this.eles.keyword || e.name.indexOf(this.eles.keyword) >= 0) && (!this.eles.type || e.type == this.eles.type));
      },
    },
    created() {
      this.$api.Element.query().then((res) => {
        this.eles.options = res.items;
      });
    },
    mounted() {
      // 解决老系统不能自动调整大小
      let _this = this;
      let times = 5;
      let res = setInterval(() => {
        _this.resize();
        times--;
        if (times <= 0) {
          clearInterval(res);
        }
      }, 3000);
    },
    methods: {
      async open() {
        let _this = this;
        let tmp = await this.$api.Tmpl.get(this.tmpl.id); // 刷新模板
        this.$utils.Obj.propertyCopy(tmp, this.tmpl);
        if (this.tmpl.docStruct) {
          this.tmpl.docStruct = JSON.parse(this.tmpl.docStruct);
        } else {
          this.tmpl.docStruct = {};
        }
        await this.$nextTick();
        let oRet = editorUtils.createDomEditor(this.$editor, this.$refs.editor);
        if (oRet.id) {
          console.log(oRet);
        }
        this.initEditorEvent();
        if (this.tmpl.apis) {
          this.checkApi(JSON.parse(this.tmpl.apis));
        }

        // if (_this.tmpl.editingVerId) {
        //   _this.verEntity = await this.$api.getTmplVer(_this.tmpl.editingVerId);
        // } else {
        //   if (_this.tmpl.ver) {
        //     let preVer = await this.$api.getTmplVer(_this.tmpl.verId);
        //     _this.verEntity = {
        //       auditState: _this.Enum.MrAuditState.草稿,
        //       ver: Number(_this.tmpl.ver) + 1,
        //       mainId: _this.tmpl.id,
        //       content: preVer.content,
        //     };
        //   } else {
        //     _this.verEntity = {
        //       auditState: _this.Enum.MrAuditState.草稿,
        //       ver: 1,
        //       mainId: _this.tmpl.id,
        //     };
        //   }
        // }
        // 改为根据最后一个版本实体判断
        if (this.editingVer) {
          this.$utils.log("当前版本实体：");
          this.$utils.log(this.editingVer);
          // 因为不含 bin 的内容，所以需要重新获取
          let preVer = await this.$api.TmplVer.get(_this.editingVer.id);
          if (this.editingVer.auditState != this.Enum.MrAuditState.通过) {
            this.verEntity = preVer;
            this.verEntity.lockKey = null;
            this.$utils.log("当前版本直接编辑");
          } else {
            this.verEntity = {
              auditState: _this.Enum.MrAuditState.草稿,
              ver: Number(_this.tmpl.ver) + 1,
              mainId: _this.tmpl.id,
              content: preVer.content,
              lockKey: null,
            };
            this.$utils.log("当前版本是通过状态，生成新版本");
          }
        } else {
          this.$utils.log("版本不存在，新建");

          this.verEntity = {
            auditState: _this.Enum.MrAuditState.草稿,
            ver: 1,
            mainId: _this.tmpl.id,
            lockKey: null,
          };
        }

        if (_this.verEntity.content) {
          oRet = _this.$editor.OpenFile(_this.verEntity.content, 2, 2);
          if (oRet.id) {
            console.log(oRet);
          }
        } else {
          oRet = _this.$editor.NewFile();
          if (oRet.id) {
            console.log(oRet);
          }
        }
      },
      initEditorEvent() {
        let _this = this;
        // bin文件加载完毕
        this.$editor.NsoFileOpenCompleted = () => {
          // console.log("编辑器已打开文件");
          _this.resize();
          _this.refreshStruct();
          // 设置文档按宽度显示
          if (_this.setting.defaultWidth) {
            _this.$editor.SetViewProportion(4, _this.setting.defaultWidth);
          } else {
            _this.$editor.SetViewProportion(3);
          }
          let oRet = _this.$editor.InitEvents();
          _this.$editor.SetUserInfo({
            UserCode: _this.user.id,
            UserName: _this.user.name,
            Department: _this.user.deptName,
            TrackColor: "00BFFF",
            TrackMark: 0,
          });
          oRet = _this.$editor.DesignTemplet();
          if (oRet.id) {
            console.log(oRet);
          }

          // 点击数据组
          _this.$editor.Events.Section.NsoSectionClick = (evt) => {
            // console.log(evt);
          };

          // 焦点进入控件（方向键）
          _this.$editor.Events.NewControl.NsoNewControlCursorEnter = (evt) => {
            _this.refreshProps(evt.ObjectName);
          };
          // 焦点离开了控件（方向键）
          _this.$editor.Events.NewControl.NsoNewControlCursorLeave = (evt) => {
            let oRet = _this.$editor.GetCurrentControlName();
            if (!oRet.Name) {
              _this.refreshProps();
            }
          };
          // 鼠标左键
          _this.$editor.Events.Mouse.NsoLButtonDown = (evt) => {
            let oRet = _this.$editor.GetCurrentControlName();
            if (oRet.Name) {
              _this.refreshProps(oRet.Name);
              return;
            }
            oRet = _this.$editor.GetCurrentTableName();
            if (oRet.TableId) {
              // console.log("table:", oRet.TableId);
              _this.refreshProps(oRet.TableId, _this.Enum.MrElementType.表格);
              return;
            }
            oRet = _this.$editor.GetCurrentSectionName();
            if (oRet.Name) {
              // console.log("Section:", oRet.Name);
              _this.refreshProps(oRet.Name, _this.Enum.MrElementType.数据组);
              return;
            }
            oRet = _this.$editor.GetCurrentRegionName();
            if (oRet.RegionId) {
              // console.log("Region:", oRet.Name);
              _this.refreshProps(oRet.Name, _this.Enum.MrElementType.病历段);
              return;
            }

            _this.refreshProps();
          };
        };
      },
      close() {
        editorUtils.removeDomEditor(this.$editor, this.$refs.editor);
        this.$emit("closed");
        this.$emit("update:visible", false);
        this.$api.Tmpl.unlock(this.tmpl.id);
      },

      editTmpl() {
        this.refreshStruct();
        this.tmplEntity = this.$utils.Obj.clone(this.tmpl);
        this.meta.showEdit = true;
      },
      tmplSaved() {
        this.$utils.Obj.propertyCopy(this.tmplEntity, this.tmpl);
        this.apiItems = [];
        if (this.tmpl.apis) {
          this.checkApi(JSON.parse(this.tmpl.apis));
        }
      },
      saveFile() {
        return new Promise((resolve, reject) => {
          let ret = this.$editor.SaveFile("bin");
          if (ret.id != 0) {
            reject(`编辑器保存失败: ${ret.desc}`);
          } else {
            resolve(ret.base64);
          }
        });
      },
      save(submit) {
        if (this.meta.saving) {
          return;
        }
        let oRet = this.$editor.IsDocModified();
        if (oRet.id) {
          console.log("执行 IsDocModified 失败", oRet.desc);
          return;
        }
        if (!oRet.isDocModified) {
          if (submit) {
            this.$utils.log("没有修改，忽略提交！");
            this.$emit("saved");
            this.$emit("update:visible", false);
          }
          return;
        }

        this.refreshStruct();

        this.meta.saving = true;
        let _this = this;
        // if (this.apiItems && this.apiItems.length) {
        //   this.tmplEntity = this.$utils.Obj.clone(this.tmpl);
        //   this.tmplEntity.docStruct = JSON.stringify(this.tmplEntity.docStruct);
        //   this.apiItems.sort((a, b) => a.seqNo - b.seqNo);
        //   this.tmplEntity.apis = JSON.stringify(this.apiItems.map((a) => a.code));
        //   this.$api.Tmpl.save(this.tmplEntity)
        //     .then((res) => {
        //       this.tmpl.lockKey = res.lockKey;
        //       this.tmplEntity.lockKey = res.lockKey;
        //     })
        //     .catch((err) => {
        //       console.log(err);
        //     });
        // }
        this.saveFile()
          .then((res) => {
            _this.verEntity.content = res;
            _this.verEntity.lockKey = null;
            if (submit) {
              _this.verEntity.auditState = this.Enum.MrAuditState.审批中;
            }
            return this.$api.TmplVer.save(_this.verEntity);
          })
          .then((res) => {
            _this.verEntity.id = res.id;
            _this.verEntity.lockKey = res.lockKey;
            _this.$message.success("保存成功！");
            if (submit) {
              _this.$api.Tmpl.patch({ id: this.tmpl.id, docStruct: JSON.stringify(this.tmpl.docStruct) });
              _this.$emit("saved");
              _this.$emit("update:visible", false);
            }
          })
          .catch((err) => {
            console.log(err);
            if (err) {
              _this.$message.error(err.message || err);
            }
          })
          .finally(() => {
            _this.meta.saving = false;
          });
      },
      audit(ok) {
        if (this.meta.saving) {
          return;
        }
        this.meta.saving = true;
        this.$api.TmplVer.audit(this.verEntity.id, ok, this.reason)
          .then((res) => {
            this.$message.success("审批成功！");
            this.$emit("saved");
            this.$emit("update:visible", false);
          })
          .catch((err) => {
            console.log(err);
            if (err) {
              this.$message.error(err.message || err);
            }
          })
          .finally(() => {
            this.meta.saving = false;
          });
      },
      insert(row) {
        // 如果焦点在控件内部，需要先跳出控件
        let oRet = this.$editor.GetCurrentControlName();
        if (oRet.id == 0) {
          this.$editor.CursorJumpOutofOneStruct(oRet.Name, true);
        }

        // 准备自定义属性
        let prop = {};
        if (row.dictType) {
          if (row.dictType.startsWith("enum.")) {
            let enu = row.dictType.replace("enum.", "");
            prop.CodeArray = this.Enum[enu];
            prop.ValueArray = this.Enum[enu];
          } else {
            prop.CodeArray = this.dict[row.dictType].map((d) => d.text);
            prop.ValueArray = this.dict[row.dictType].map((d) => d.text);
          }
        }

        Object.keys(row).forEach((k) => {
          if (row[k] != null && row[k] != "") {
            prop[k] = row[k];
          }
        });
        // 如果有标签先插入文本
        if (row.label) {
          this.$editor.InsertText(`${row.label}：`, 0);
        }

        // 获取有效名称（因为名称可能已经用过了）
        let validName = this.getValidName(row.name);
        prop.dataName = validName; // 名字作为自定义属性
        switch (row.type) {
          case this.Enum.MrElementType.病历段:
            this.$editor.InsertRegion(validName);
            this.$editor.CursorJumpToOneStruct(validName, false);
            if (row.content) {
              this.$editor.ImportFile(row.content);
            }
            this.$editor.CursorJumpOutofOneStruct(validName, true);
            this.$editor.SetRegionProperty(validName, prop);
            this.$utils.log("插入病历段");
            let ort = this.$editor.GetRegionProperty(validName, ["dataName"]);
            this.$utils.log(ort);
            break;
          case this.Enum.MrElementType.表格:
            let cols = JSON.parse(row.cols);
            let oRet = this.$editor.InsertTable(validName, cols.length, 2, 1);
            // console.log(oRet);
            validName = oRet.TableId; // 编辑器限制，表格不能指定名字
            let headerNams = [];
            String.fromCharCode(65);
            for (let i = 0; i < cols.length; i++) {
              headerNams.push(`${String.fromCharCode("A".charCodeAt() + i)}1`);
            }
            this.$editor.PutCellContentByArray(
              validName,
              headerNams,
              cols.map((col) => col.name)
            );
            this.$editor.CursorJumpOutofOneTable(validName, 1);
            this.$editor.SetTableProperty(validName, prop);
            break;
          case this.Enum.MrElementType.数据组:
            this.$editor.InsertSection(validName);
            this.$editor.SetSectionProperty(validName, prop);
            // 递归插入所有子元素
            if (row.eleNames) {
              let items = JSON.parse(row.eleNames);
              items.forEach((i) => {
                let ele = this.eles.options.find((f) => f.name == i);
                this.insert(ele);
              });
              this.$editor.CursorJumpOutofOneStruct(validName, true); // 插完子元素以后再跳出结构
            }
            break;
          default:
            this.$editor.InsertNewControl(validName, null, editorUtils.getTypeCode(row.type));
            this.$editor.CursorJumpOutofOneStruct(validName, true);
            this.$editor.SetNewControlProperty(validName, prop);
            break;
        }
        // 如果元素绑定了接口，补充绑定内容到元数据
        this.checkApi(row.getApi);
      },
      refreshProps(actName, type) {
        this.eles.actType = type;

        if (!actName) {
          this.eles.actProps = [];
          this.eles.actName = null;
          return;
        }
        if (this.eles.actName == actName) {
          return;
        }
        this.eles.actName = actName;
        let oRet;
        if (!type) {
          oRet = this.$editor.GetNewControlProperty(actName, ["type"]);
          type = oRet.props.type;
        }

        if (editorUtils.isKnown(type)) {
          if (type == this.Enum.MrElementType.表格) {
            oRet = this.$editor.GetTableProperty(actName, editorUtils.getPropCodes(type));
          } else if (type == this.Enum.MrElementType.数据组) {
            oRet = this.$editor.GetSectionProperty(actName, editorUtils.getPropCodes(type));
          } else if (type == this.Enum.MrElementType.病历段) {
            oRet = this.$editor.GetRegionProperty(actName, editorUtils.getPropCodes(type));
          } else {
            oRet = this.$editor.GetNewControlProperty(actName, editorUtils.getPropCodes(type));
          }
          this.$utils.log(oRet.props);
          if (oRet.props.getRes) {
            oRet.props.getRes = oRet.props.getRes.split(".");
          }
          this.eles.actProps = editorUtils.getValidProps(type, oRet.props, this.eles.actName).filter((p) => !p.hide);

          if (!editorUtils.isKnown(oRet.props.getRes)) {
            oRet = this.$editor.GetFatherStructName(actName);
            this.$utils.log(`name: ${actName} father: ${oRet.fatherStructName}`);
          }
        } else {
          this.eles.actProps = [];
        }
      },
      collapseChange(name) {
        if (name == "struct") {
          this.refreshStruct();
        }
      },
      refreshStruct() {
        this.tmpl.docStruct = genStructData(this.$editor);
        // // let res = this.$editor.GetStructsXmlInfo(1, true)
        // // let doc = this.$x2js.xml2js(res.structsXmlInfo).Root.DocObjContent
        // let res = this.$editor.GetStructsXmlInfoByParament(1, true, true, "AllProperty", "AllProperty", "dataName");
        // // console.log(res.structsXml);
        // let doc = this.$x2js.xml2js(res.structsXml).Root.DocObjContent;
        // this.$utils.log("原始xml解析结果：")
        // this.$utils.log(doc);
        // this.tmpl.docStruct = {};
        // this.genStruct(doc, this.tmpl.docStruct);
        // this.$utils.log("结构生成结果：")
        // this.$utils.log(this.tmpl.docStruct);
      },
      genTree(obj) {
        if (!obj) {
          obj = {};
        }
        return Object.keys(obj).map((k) => {
          let ele = obj[k];
          let nod = {
            label: k,
          };
          if (Array.isArray(ele)) {
            nod.isArray = true;
            if (ele.length && typeof ele[0] === "object") {
              nod.children = this.genTree(ele[0]);
            }
          } else if (ele != null && typeof ele === "object") {
            nod.children = this.genTree(ele);
          }
          return nod;
        });
      },
      genStruct(obj, target) {
        if (Array.isArray(obj)) {
          obj.forEach((o) => {
            this.genStruct(o, target);
          });
          return;
        }
        Object.keys(obj).forEach((k) => {
          let ele = obj[k];
          if (k == "Section" || k == "Region") {
            if (Array.isArray(ele)) {
              ele.forEach((e) => {
                target[e._Name] = {};
                this.genStruct(e, target[e._Name]);
              });
            } else {
              target[ele._Name] = {};
              this.genStruct(ele, target[ele._Name]);
            }
          } else if (k == "NewCtrl") {
            if (Array.isArray(ele)) {
              ele.forEach((e) => {
                target[e._dataName || e._Name] = e.ParaRun.Text;
                // target[e._Name] = e.ParaRun.Text;
              });
            } else {
              target[ele._dataName || ele._Name] = ele.ParaRun.Text;
              // target[ele._Name] = ele.ParaRun.Text;
            }
          } else if (typeof ele === "object") {
            this.genStruct(ele, target);
          }
        });
      },
      getValidName(name) {
        let res = this.$editor.GetObjectType(name);
        if (res.objectType == "-1") {
          return name;
        }
        if (name.indexOf("-") > 1) {
          return this.getValidName(`${name.split("-")[0]}-${Number(name.split("-")[1]) + 1}`);
        } else {
          return this.getValidName(`${name}-1`);
        }
      },
      nodeClick(row) {
        this.$editor.CursorJumpToOneStruct(row.label.split("：")[0], true);
      },
      typeName(code) {
        return editorUtils.getTypeName(code);
      },
      cellStyle(cell) {
        if (cell.columnIndex == 0) {
          return {
            // "background-color": "WhiteSmoke",
            color: "gray",
          };
        }
        return null;
      },
      propChanged(row) {
        console.log(this.$editor.SetDocModified(true));

        // console.log(row);
        let prop = {};
        if (row.type == "data" && row.value) {
          prop[row.code] = row.value.join(".");
        } else {
          prop[row.code] = row.value;
        }
        let oRet;
        let type = this.eles.actType;
        let actName = this.eles.actName;
        switch (this.eles.actType) {
          case this.Enum.MrElementType.表格:
            oRet = this.$editor.SetTableProperty(actName, prop);
            break;
          case this.Enum.MrElementType.数据组:
            oRet = this.$editor.SetSectionProperty(actName, prop);
            break;
          case this.Enum.MrElementType.病历段:
            oRet = this.$editor.SetRegionProperty(actName, prop);
            break;
          default:
            oRet = this.$editor.SetNewControlProperty(actName, prop);
            break;
        }
      },
      checkApi(apiCodes) {
        if (!apiCodes) {
          return;
        }
        if (!(apiCodes instanceof Array)) {
          apiCodes = [apiCodes];
        }
        apiCodes.forEach((code) => {
          if (this.apiItems.findIndex((a) => a.code == code) == -1) {
            let a = this.apis.find((a) => a.code == code);
            if (a) {
              this.apiItems.push(a);
            }
          }
        });
      },
      eleFilterChanged(opt) {
        if (!opt.type.length) {
          this.eles.type = null;
        } else {
          this.eles.type = opt.type[0];
        }
        // console.log(this.eles.type);
      },
      insertMeta(nodeData, node) {
        if (node.childNodes.length > 0) return;

        let data = editorUtils.structTree2Ele(node);

        this.insert(data);
      },
      switchSideShow() {
        this.meta.showAside = !this.meta.showAside;
        this.$nextTick(() => {
          let oRet = this.$editor.GetSize();
          oRet = this.$editor.SetSize(this.$refs.main.$el.clientWidth, this.$refs.main.$el.clientHeight - 4);
        });
      },
      print() {
        this.$editor.Preview();
      },
      addMrPart() {
        let oet = this.$editor.CopyWithStruct(true);
        // console.log(oet);

        if (oet.structNames) {
          this.$prompt(`选中内容包含（${oet.structNames}），若要将选中内容保存为病历段，请输入病历段名称`, "新建病历段")
            .then(({ value }) => {
              oet = this.$editor.SaveSelectAreaToFile(3, 0);
              // console.log(oet);
              return this.$api.Element.save({
                name: value,
                type: this.Enum.MrElementType.病历段,
                content: oet.base64,
              });
            })
            .then((res) => {
              this.eles.options.push(res);
              this.$message.success("保存成功！");
            })
            .catch((err) => {
              console.log(err);
            });
        }
      },
      resize() {
        this.$nextTick(() => {
          // 调整编辑器大小，占满剩余区域
          try {
            let oRet = this.$editor.GetSize();
            oRet = this.$editor.SetSize(this.$refs.main.$el.clientWidth, this.$refs.main.$el.clientHeight - 4);
          } catch (err) {
            // console.log(err)
          }
        });
      },
    },
  };
</script>
